/**
 * Redirect Buy Now Button to Cart
 * This script intercepts the Shopify dynamic checkout button
 * and redirects to cart instead of checkout when enabled
 */

(function() {
  'use strict';

  function init() {
    // Wait for the DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachRedirectHandlers);
    } else {
      attachRedirectHandlers();
    }
  }

  function attachRedirectHandlers() {
    // Find all buy-it-now containers with redirect enabled
    const buyItNowContainers = document.querySelectorAll('[data-buy-it-now][data-redirect-to-cart="true"]');
    
    if (buyItNowContainers.length === 0) {
      return;
    }

    buyItNowContainers.forEach(container => {
      // Use MutationObserver to detect when Shopify adds the payment button
      const observer = new MutationObserver((mutations) => {
        const paymentButton = container.querySelector('.shopify-payment-button__button--unbranded, shopify-buy-it-now-button button');
        
        if (paymentButton && !paymentButton.dataset.redirectAttached) {
          attachClickHandler(paymentButton, container);
          paymentButton.dataset.redirectAttached = 'true';
        }
      });

      observer.observe(container, {
        childList: true,
        subtree: true
      });

      // Check if button already exists
      const existingButton = container.querySelector('.shopify-payment-button__button--unbranded, shopify-buy-it-now-button button');
      if (existingButton && !existingButton.dataset.redirectAttached) {
        attachClickHandler(existingButton, container);
        existingButton.dataset.redirectAttached = 'true';
      }
    });
  }

  function attachClickHandler(button, container) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Find the product form
      const form = container.closest('form[action*="/cart/add"]') || 
                   container.closest('[data-product-form]')?.querySelector('form') ||
                   document.querySelector('form[action*="/cart/add"]');

      if (!form) {
        console.error('Product form not found');
        return;
      }

      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || 1);

      if (!variantId) {
        console.error('Variant ID not found');
        return;
      }

      // Show loading state if possible
      const loadingClass = 'is-loading';
      button.classList.add(loadingClass);
      button.disabled = true;

      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Redirect to cart
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        button.classList.remove(loadingClass);
        button.disabled = false;
        
        // Show error message if possible
        alert('Error al agregar el producto al carrito. Por favor, intenta nuevamente.');
      });
    }, true); // Use capture phase to intercept before other handlers
  }

  // Initialize
  init();

  // Re-initialize on dynamic content changes (for quick view, etc.)
  document.addEventListener('shopify:section:load', attachRedirectHandlers);
  document.addEventListener('theme:product:loaded', attachRedirectHandlers);
})();

